import { render, staticRenderFns } from "./FactsheetCollection.vue?vue&type=template&id=45f2e7a8&scoped=true"
import script from "./FactsheetCollection.vue?vue&type=script&lang=js"
export * from "./FactsheetCollection.vue?vue&type=script&lang=js"
import style1 from "./FactsheetCollection.vue?vue&type=style&index=1&id=45f2e7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f2e7a8",
  null
  
)

export default component.exports